import React, { useState } from 'react'
import { Box, Button } from '@mui/material';
import CounselListContainer from '../../../containers/employeemng/resume/CounselListContainer'
import CounselFormContainer from '../../../containers/employeemng/resume/CounselFormContainer';

const CounselTemplate = ({ edit, employee }) => {
    const [data, setData] = useState(null);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setData(null);
    };

    const editFunction = (params) => {
        //console.log(params, 'parent');
        setData(params);
        setOpen(true);
    };


    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'wrap',
                    m: 1,
                }}
            >
                {edit &&
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 1 }}>
                        <Box textAlign="center">
                            <Button color="primary" variant="contained" onClick={handleOpen}>
                                추가
                            </Button>
                        </Box>
                    </Box>
                }

                <CounselListContainer employee={employee} editFunction={editFunction} />
                <CounselFormContainer
                    employee={employee}
                    type={data != null ? 'edit' : 'add'}
                    data={data}
                    open={open}
                    handleClose={handleClose}
                />

            </Box>
        </>

    )
}

export default CounselTemplate